<template>
    <TheLayout type="base">
        <main class="index-view container">
            <SectionLayout class="index-view__section" large>
                <TheIntroduction />
            </SectionLayout>

            <InsuranceProcess id="process"
                class="index-view__section"
                :showModalSubsciptionCancel = "showModalSubsciptionCancel"
                @close-cancel-modal="showModalSubsciptionCancel = false"
            />

            <SectionLayout
                class="index-view__section" 
                title="Подписку легко оформить" 
                bg-theme="primary-invert"
                title-bottom-margin-size="big"
                >
                <ExecutionSteps />
            </SectionLayout>

            <SectionLayout class="index-view__section" 
                bg-theme="primary"
                bg-with-image
                is-call-to-action
                >
                <CallToAction title="Оформите подписку прямо сейчас"
                    submit-button-text="Оформить подписку"
                    :submit-button-callback="callToActionCallback" />
            </SectionLayout>

            <SectionLayout id="advantages"
                class="index-view__section" 
                title="Преимущества страхования для бизнеса" 
                bg-theme="primary-invert"
                title-bottom-margin-size="big"
                >
                <BusinessAdvantages />
            </SectionLayout>

            <SectionLayout class="index-view__section" 
                title="Для кого подойдет подписка" 
                bg-theme="primary-invert"
                title-bottom-margin-size="big"
                >
                <ForWho />
            </SectionLayout>

            <SectionLayout class="index-view__section" 
                title="Что будет застраховано" 
                bg-theme="primary-invert"
                >
                <InsuranceTargets />
            </SectionLayout>

            <SectionLayout class="index-view__section" 
                bg-theme="primary"
                bg-with-image
                >
                <CallToAction title="Оформите полис в течение 1 минуты"
                    submit-button-text="Оформить подписку"
                    :submit-button-callback="callToActionCallback"
                    is-call-to-action
                    />
            </SectionLayout>

            <SectionLayout class="index-view__section" 
                title="Как получить компенсацию"
                bg-theme="primary-invert"
                >
                <CompensationSteps />
            </SectionLayout>

            <SectionLayout id="faq"
                class="index-view__section" 
                title="Частые вопросы"
                bg-theme="primary-invert"
                >
                <TheFaq
                @cancel-subscription="showModalSubsciptionCancel = true"
                />
            </SectionLayout>

            <SectionLayout class="index-view__section" 
                bg-theme="primary"
                bg-with-image
                >
                <CallToAction title="Оформите подписку на страхование имущества для юридических лиц за одну минуту"
                    submit-button-text="Оформить подписку"
                    :submit-button-callback="callToActionCallback"
                    is-call-to-action
                    />
            </SectionLayout>
        </main>
        <ModalPolicyIssuanceSuccess
            :visible="showPolicyIssuanceSuccessModal"
            modal-width="719px"
            @close="showPolicyIssuanceSuccessModal = false" />
    </TheLayout>
</template>

<script>
import TheLayout from '@/components/layouts/TheLayout';
import SectionLayout from '@/components/layouts/SectionLayout';
import TheIntroduction from '@/components/pages/index/TheIntroduction';
import InsuranceProcess from '@/components/pages/index/InsuranceProcess';
import ExecutionSteps from '@/components/pages/index/ExecutionSteps';
import CallToAction from '@/components/pages/index/CallToAction';
import BusinessAdvantages from '@/components/pages/index/BusinessAdvantages';
import ForWho from '@/components/pages/index/ForWho';
import InsuranceTargets from '@/components/pages/index/InsuranceTargets';
import CompensationSteps from '@/components/pages/index/CompensationSteps';
import TheFaq from '@/components/pages/index/TheFaq';
import ModalPolicyIssuanceSuccess from '@/components/modals/ModalPolicyIssuanceSuccess';

import scrollTo from '@/mixins/scrollTo';
import { GLOBAL_MODAL_KEYS_MAP } from '@/consts';

export default {
    name: 'IndexView',
    components: {
        TheLayout,
        SectionLayout,
        TheIntroduction,
        InsuranceProcess,
        ExecutionSteps,
        CallToAction,
        BusinessAdvantages,
        ForWho,
        InsuranceTargets,
        CompensationSteps,
        TheFaq,
        ModalPolicyIssuanceSuccess
    },
    mixins: [scrollTo],
    data() {
        return {
            showPolicyIssuanceSuccessModal: false,
            showModalSubsciptionCancel: false,
        }
    },
    methods: {
        callToActionCallback() {
            this.scrollTo('process')
        }
    },
    created() {
      document.title = 'Страхование имущества юридических лиц - Zetta страхование';
    },
    mounted() {
        const { message } = this.$route.query;

        switch (message) {
            case GLOBAL_MODAL_KEYS_MAP.successPolicyIssuance:
                this.showPolicyIssuanceSuccessModal = true;
                break;
            default:
                break;
        }
    }
}
</script>

<style scoped lang="scss">
.index-view {
    &__section {
        $vertical-margin-desktop: $gap-large;
        $vertical-margin-desktop-min: 40px;

        @include resetting-vertical-indentation-of-first;

        margin-top: rem($vertical-margin-desktop);

        @media (#{$screen-big}) {
            margin-top: rem($vertical-margin-desktop-min);
        }
    }
}
</style>